import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import "./social-media-compose-landing-card.scss"
import { motion, useInView } from 'framer-motion';

const SocialMediaComposeLandingCard = () => {
    const scrollBreakpointRef = useRef<HTMLDivElement>(null)
    const imageUploaderRefs = useRef<ImageUploaderRef[]>([]);

    const inView = useInView(scrollBreakpointRef, { amount: 0.6 })

    useEffect(() => {
        if (!imageUploaderRefs.current) return
        if (inView) {
            for (let ref of imageUploaderRefs.current) {
                ref.animate()
            }
        }
    }, [inView])


    return (
        <div ref={scrollBreakpointRef} className='emrg-demo-cards compose-card'>
            <div className='card-header'>
                <h3>Compose</h3>
                <p className='color-gray-300'>Launch content to various social media platforms</p>
            </div>
            <div className='compose-wrapper'>
                <div className='emp-compose-card'>
                    <span className='title color-gray-0'>Create a Post</span>
                    <label className='color-gray-100 block mt-6'>Images for upload<span>*</span></label>
                    <p className='color-gray-200'>Please provide at least one media file for upload</p>
                    <ImageUploader sequence={0} ref={(el: ImageUploaderRef) => imageUploaderRefs.current[0] = el}
                        postName={'PRIME in Korea.png'}
                        image={'https://media.karousell.com/media/photos/products/2022/10/24/prime_hydration_1666620952_3c0c3c93_progressive'} />
                    <div className='mt-2'>
                        <ImageUploader sequence={1} ref={(el: ImageUploaderRef) => imageUploaderRefs.current[1] = el}
                            postName={'Flavours Assortment.png'}
                            image={'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSnb0rbc2MI3Hfce8rOlE4v3SaAVWYNXONv_AdBmyC_8EzR7CnHLGnSpfwuHamiuJ8ohY&usqp=CAU'} />
                    </div>
                    <div className='mt-2'>
                        <ImageUploader sequence={2} ref={(el: ImageUploaderRef) => imageUploaderRefs.current[2] = el}
                            postName={'Call to action.png'}
                            image={'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXKFXuvv6U3GumwDO5kTShh0-rgBvIOmLaZAn1vQLjj55Vs7kHBhuz9usaSSoOusdKmQA&usqp=CAU'} />
                    </div>
                </div>
            </div>
        </div>)
}
export default SocialMediaComposeLandingCard

interface ImageUploaderProps {
    postName: string,
    image: string,
    sequence: number
}

interface ImageUploaderRef {
    animate: () => void
}

const ImageUploader = forwardRef((props: ImageUploaderProps, ref) => {
    const { sequence, postName, image } = props

    const [variantState, setVariantState] = useState<"hidden" | "visible">("hidden")
    const BASE_DELAY_S = 0.2;

    const wrapperVariant = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 }
    }
    const progressBarVariant = {
        hidden: { width: "0%" },
        visible: { width: "100%" }
    }

    useImperativeHandle(ref, () => {
        return {
            animate
        }
    })

    const animate = () => {
        setVariantState("visible")
    }
    return (
        <motion.div className='img-uploader'
            variants={wrapperVariant}
            initial={variantState}
            animate={variantState}
            transition={{ delay: sequence * BASE_DELAY_S, type: "tween", duration: 0.8 }}>
            <img alt="instagram icon" src={image} />
            <div className='details-wrapper ml-3'>
                <span className='block mt-1 file-name-txt'>{postName}</span>
                <div className='progress-track mt-3'>
                    <motion.div className='progress-bar'
                        variants={progressBarVariant}
                        initial={variantState}
                        animate={variantState}
                        transition={{ delay: sequence * BASE_DELAY_S + (0.3 * sequence), type: "tween", duration: 4 }}>

                    </motion.div>
                </div>
            </div>
        </motion.div >
    )
})
